import React, { useState, useEffect } from "react";
import { Spin, Flex } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import Order from "./Order";
import backDrawerIcon from "../../assets/images/back-drawer-icon.svg";
import emptyOrdersIcon from "../../assets/images/empty-orders.svg";
import { ResponsiveSortControl } from "../common/MobileActionSheet";
import { clearSearchListReturn } from "../../utils/searchReturnState";

let timeout = null;

const Orders = ({
  orders,
  initialFetch,
  setShowOnMap,
  setOrdersInitial,
  setParentOrders,
  onBackToSearchForm,
}) => {
  const [loading, setLoading] = useState(false);
  const [selectedSort, setSelectedSort] = useState("-date");
  const [_orders, setOrders] = useState(null);
  const [display, setDisplay] = useState(null);

  useEffect(() => {
    if (localStorage.getItem("display-grid")) {
      setDisplay(localStorage.getItem("display-grid"));
    } else {
      const body = document.querySelector("body");
      if (body.classList.contains("small-grid")) {
        setDisplay("small-grid");
      } else {
        setDisplay("big-grid");
      }
    }

    return () => {
      const body = document.querySelector("body");
      body.classList.remove("big-grid");
      body.classList.remove("small-grid");
    };
  }, []);

  useEffect(() => {
    if (display) {
      const body = document.querySelector("body");
      if (display === "big-grid") {
        body.classList.add("big-grid");
        body.classList.remove("small-grid");
        localStorage.setItem("display-grid", "big-grid");
      } else {
        body.classList.add("small-grid");
        body.classList.remove("big-grid");
        localStorage.setItem("display-grid", "small-grid");
      }
    }
  }, [display]);

  const exchangeRates = [
    { value: 4, rate: 1 },
    { value: 2, rate: 1.1 },
    { value: 1, rate: 87.5 },
    { value: 3, rate: 0.17 },
  ];

  const getConvertedPrice = (price, currency) => {
    if (!currency || !price) return price || 0;
    const rate = exchangeRates.find((r) => r.value === currency)?.rate || 1;
    return price * rate;
  };

  useEffect(() => {
    if (!orders) return;

    const sortedOrders = orders.sort((a, b) => {
      if (selectedSort === "date") {
        const aDate = new Date(a.created_at);
        const bDate = new Date(b.created_at);
        return aDate - bDate;
      } else if (selectedSort === "-date") {
        const aDate = new Date(a.created_at);
        const bDate = new Date(b.created_at);
        return bDate - aDate;
      } else if (selectedSort === "price") {
        // Orders with null price always go to the end
        if (!a.price && !b.price) return 0;
        if (!a.price) return 1;
        if (!b.price) return -1;

        const aConvertedPrice = getConvertedPrice(a.price, a.currency);
        const bConvertedPrice = getConvertedPrice(b.price, b.currency);
        return aConvertedPrice - bConvertedPrice;
      } else if (selectedSort === "-price") {
        // Orders with null price always go to the end
        if (!a.price && !b.price) return 0;
        if (!a.price) return 1;
        if (!b.price) return -1;

        const aConvertedPrice = getConvertedPrice(a.price, a.currency);
        const bConvertedPrice = getConvertedPrice(b.price, b.currency);
        return bConvertedPrice - aConvertedPrice;
      }
    });
    setOrders(sortedOrders);
  }, [orders, selectedSort]);

  const items = [
    {
      key: "-date",
      label: (
        <div
          className={`transports__sorting__menu__item ${selectedSort === "-date" ? "active" : ""}`}
        >
          Сначала новые
        </div>
      ),
    },
    {
      key: "date",
      label: (
        <div
          className={`transports__sorting__menu__item ${selectedSort === "date" ? "active" : ""}`}
        >
          Сначала старые
        </div>
      ),
    },
    {
      key: "price",
      label: (
        <div
          className={`transports__sorting__menu__item ${selectedSort === "price" ? "active" : ""}`}
        >
          Возрастанию цены
        </div>
      ),
    },
    {
      key: "-price",
      label: (
        <div
          className={`transports__sorting__menu__item ${selectedSort === "-price" ? "active" : ""}`}
        >
          Убыванию цены
        </div>
      ),
    },
  ];

  const sortClick = (val) => {
    setLoading(true);
    if (val.key !== selectedSort) {
      setSelectedSort(val.key);
    }
    timeout = setTimeout(() => {
      setLoading(false);
    }, 500);
  };

  const backToSearchForm = () => {
    if (onBackToSearchForm) {
      onBackToSearchForm();
      return;
    }
    clearSearchListReturn("orders");
    if (setOrdersInitial) setOrdersInitial(true);
    if (setParentOrders) setParentOrders(null);
  };

  return (
    <div className="transports">
      {loading && (
        <div className="transport-search-full-screen">
          <Flex align="center" gap="middle">
            <Spin
              indicator={<LoadingOutlined style={{ fontSize: 48 }} spin />}
            />
          </Flex>
        </div>
      )}
      <div className="transports__top transports__top--desktop-mt">
        {initialFetch && orders && (
          <div className="transports__title">
            Найдите подходящий груз: {orders.length}
          </div>
        )}
        {!initialFetch && orders && (
          <div className="transports__title mobile-centered-title mobile-centered-title--orders">
            <div className="mobile-only back-button-svg" onClick={backToSearchForm}>
              <img src={backDrawerIcon} alt="back" style={{ width: '34px', height: '34px', display: 'block' }} />
            </div>
            <span className="desktop-only">Результаты поиска: {orders.length}</span>
            <span className="mobile-only">Найдите подход. груз</span>
          </div>
        )}
        <div className="transports__sorting">
          <ResponsiveSortControl items={items} onClick={sortClick} />
        </div>
        <div className="sorting-switcher">
          <div
            className={`sorting-switcher__item ${display === "big-grid" ? "active" : ""}`}
            onClick={() => setDisplay("big-grid")}
          />
          <div
            className={`sorting-switcher__item ${display === "small-grid" ? "active" : ""}`}
            onClick={() => setDisplay("small-grid")}
          />
        </div>
      </div>
      {_orders && _orders.length === 0 && (
        <div className="transport__empty transport__empty--orders">
          <div className="transport__empty__text">
            По вашему запросу грузов не найдено
          </div>
          <img
            src={emptyOrdersIcon}
            alt=""
            aria-hidden="true"
            className="transport__empty__icon"
          />
        </div>
      )}
      {_orders && orders.length > 0 && (
        <div className="grid-table grid-table--orders">
          <div className="grid-table__item">Дата</div>
          <div className="grid-table__item grid-table__item--from-to">
            <span>Откуда</span>
            <span>Куда</span>
          </div>
          <div className="grid-table__item">Описание</div>
          <div className="grid-table__item">Стоимость</div>
          <div className="grid-table__item">Контактное лицо</div>
        </div>
      )}
      {_orders &&
        _orders.map((order) => (
          <Order
            key={order.uuid}
            order={order}
            setShowOnMap={setShowOnMap}
            setLoading={setLoading}
            fetchInitial={() => { }}
            returnListType="orders"
            returnListSnapshot={_orders}
          />
        ))}
    </div>
  );
};

export default Orders;
